"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refunds = void 0;
var utils_1 = require("../../utils");
exports.refunds = function (axios) {
    return {
        // 환불목록 조회
        getRefunds: function (request) {
            return axios.get('/refunds', request);
        },
        getRefundsV2: function (request) {
            return axios.get('/refunds', request);
        },
        // 환불 목록에서 사용될 검색조건을 조회
        getRefundsSearchConditions: function (request) {
            return axios.get('/refunds/search-conditions', request);
        },
        // 환불 계좌 변경
        putRefundsNoAccount: function (request) {
            var url = utils_1.paramPathchange('/refunds/{no}/account', request);
            return axios.put(url, request.data);
        }
    };
};
